import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'
import { TestResultContextProvider } from '../context/TestResultContext'
import { SelectedTestProvider } from '../context/SelectedTest'
import CreateQuestionWizard from '../component/session/createWizard/CreateQuestionWizard'

// Route host for the step-by-step question wizard (/session/new).
//
// The route is already wrapped in DashboardProviders (App.js), which supplies
// SelectedCodeContext and ModeContext - both required by the panels the wizard embeds.
// TestResultContext is NOT part of that stack: it is mounted at Home.jsx:163, inside
// /session/:id only, and TestList destructures it with no default value, so it has to be
// provided here or TestList throws the moment the Testcases step renders.
const CreateQuestionPage = () => {
  const { currentUser } = useContext(AuthContext)

  // Same threshold the session list uses to show "Add Session" (SessionTable.jsx:255).
  if (currentUser && currentUser.role > 1) {
    return <Navigate to="/session" replace />
  }

  return (
    <SelectedTestProvider>
      <TestResultContextProvider>
        <CreateQuestionWizard />
      </TestResultContextProvider>
    </SelectedTestProvider>
  )
}

export default CreateQuestionPage
